import React from 'react';
export const MiniTestimonials: React.FC = () => {
  return <section className="bg-[#F5F5EB] py-10 px-5" data-id="element-141" data-mp="fwra6h43s7jo">
      <div className="grid grid-cols-[repeat(auto-fit,minmax(280px,1fr))] gap-5 max-w-[1000px] mx-auto" data-id="element-142" data-mp="3ktezfbb6tqr2">
        <div className="bg-white rounded-xl p-5 shadow-[0_3px_15px_rgba(0,0,0,0.06)] flex gap-3.5 items-start" data-id="element-143" data-mp="370pbh1c3mbrb">
          <div className="w-11 h-11 rounded-full flex items-center justify-center font-black font-sans text-sm text-white shrink-0 bg-brown-mid" data-id="element-144" data-mp="3b20zx3j8kqxx">
            JP
          </div>
          <div className="flex-1" data-id="element-145" data-mp="322xgtzk2kbjf">
            <div className="text-gold-main text-sm tracking-[1px] mb-1.5" data-id="element-146" data-mp="323yw6g84bk6y">
              ★★★★★
            </div>
            <p className="text-[13px] text-[#444] font-sans italic leading-[1.5] mb-1.5" data-id="element-147" data-mp="2o4z2uv9nuh4g">
              "El Tomo 2 me dio la ingeniería real. Levanté mis muros en 3
              semanas sin ningún error."
            </p>
            <div className="text-xs font-bold text-green-brand font-sans" data-id="element-148" data-mp="qcuvzn9rmt9r">
              — Juan P.
            </div>
            <div className="text-[11px] text-[#999] font-sans" data-id="element-149" data-mp="2qhgd8dftknu">
              📍 Salta, Argentina
            </div>
          </div>
        </div>

        <div className="bg-white rounded-xl p-5 shadow-[0_3px_15px_rgba(0,0,0,0.06)] flex gap-3.5 items-start" data-id="element-150" data-mp="3tx0mwbc8qogc">
          <div className="w-11 h-11 rounded-full flex items-center justify-center font-black font-sans text-sm text-white shrink-0 bg-green-mid" data-id="element-151" data-mp="civkg7rzn3d6">
            MS
          </div>
          <div className="flex-1" data-id="element-152" data-mp="3fy16ts2snhvs">
            <div className="text-gold-main text-sm tracking-[1px] mb-1.5" data-id="element-153" data-mp="3ayfzat9k617g">
              ★★★★★
            </div>
            <p className="text-[13px] text-[#444] font-sans italic leading-[1.5] mb-1.5" data-id="element-154" data-mp="3pvfaer3mcc6o">
              "La calculadora Eco-Estimator me ahorró una fortuna. El Tomo 3 de
              acabados es pura magia."
            </p>
            <div className="text-xs font-bold text-green-brand font-sans" data-id="element-155" data-mp="154ey0w02cevb">
              — Marina S.
            </div>
            <div className="text-[11px] text-[#999] font-sans" data-id="element-156" data-mp="105v7eiaiyewm">
              📍 Montevideo, Uruguay
            </div>
          </div>
        </div>

        <div className="bg-white rounded-xl p-5 shadow-[0_3px_15px_rgba(0,0,0,0.06)] flex gap-3.5 items-start" data-id="element-157" data-mp="1c8ed1swgw483">
          <div className="w-11 h-11 rounded-full flex items-center justify-center font-black font-sans text-sm text-white shrink-0 bg-brown-dark" data-id="element-158" data-mp="1h77v7ymp8jel">
            RM
          </div>
          <div className="flex-1" data-id="element-159" data-mp="oj3n76gnnu8q">
            <div className="text-gold-main text-sm tracking-[1px] mb-1.5" data-id="element-160" data-mp="ok4xv9treepx">
              ★★★★★
            </div>
            <p className="text-[13px] text-[#444] font-sans italic leading-[1.5] mb-1.5" data-id="element-161" data-mp="tiycx6op2ds7">
              "La guía de legalidad fue clave. El municipio aprobó mi proyecto
              en 3 semanas."
            </p>
            <div className="text-xs font-bold text-green-brand font-sans" data-id="element-162" data-mp="139assllkdis0">
              — Roberto M.
            </div>
            <div className="text-[11px] text-[#999] font-sans" data-id="element-163" data-mp="5qrjoge9mmx0">
              📍 Santiago, Chile
            </div>
          </div>
        </div>
      </div>
    </section>;
};